import { render } from "./CheckBoxInputPair.vue?vue&type=template&id=f452b8e4"
import script from "./CheckBoxInputPair.vue?vue&type=script&lang=js"
export * from "./CheckBoxInputPair.vue?vue&type=script&lang=js"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__